import ProductDetails from '../components/ProductDetails';
import ProductGallery from '../components/ProductGallery';
import Sidebar from '../components/Sidebar';

export default class Product {
  constructor(section) {
    this.el = section.el;
    this.data = section.data;
    this.onboarding = this.data.onboarding;
    this.product = this.data.product;
    this.variantInventory = this.data.variantInventory;
    this.sidebarEl = this.el.querySelector('[data-sidebar-top]');
    this.sidebarBottomEl = this.el.querySelector('[data-sidebar-bottom]');

    this.productGallery = new ProductGallery({
      el: this.el,
      product: this.product,
      settings: this.data,
    });

    if (this.onboarding) { return; }

    this.productDetails = new ProductDetails({
      el: this.el,
      product: this.product,
      variantInventory: this.variantInventory,
      settings: this.data,
      onVariantChange: variant => {
        this.productGallery.updateGalleryImageByVariant(variant);
      },
    });

    // We need to initialize 2 sidebars because on desktop the normal sidebar is used,
    // and on mobile, if a bottom sidebar is used, we have it there.
    // The sidebar class determines if the sidebar exists.
    this.sidebar = new Sidebar(this.sidebarEl);
    this.sidebarBottom = new Sidebar(this.sidebarBottomEl);
  }

  unload() {
    if (this.productDetails) {
      this.productDetails.unload();
    }

    if (this.productGallery) {
      this.productGallery.unload();
    }

    if (this.sidebar) {
      this.sidebar.unload();
    }

    if (this.sidebarBottom) {
      this.sidebarBottom.unload();
    }
  }

  onSectionUnload() {
    this.unload();
  }
}
